/**
 * EntityType defines the types of entities in the Seller University ecosystem.
 * These values are manually synchronized with [SellerUCommonModels](https://code.amazon.com/packages/SellerUCommonModels)
 * to maintain consistent entity type identification across our frontend and backend systems.
 * */
export enum EntityType {
  LearningPathway = 'LEARNING_PATHWAY',
  Topic = 'TOPIC',
  SearchPage = 'SEARCH_PAGE',
  ModulePage = 'MODULE_PAGE',
  HomePage = 'HOME_PAGE',
  Widget = 'WIDGET',
}

// Topic IDs where Interactive Content Banner should be displayed
export const LISTING_TOPIC_IDS = [
  '267f5f30-2824-4be0-8e35-c7e0ed61c0b7', // Gamma & Prod
  '7df5313b-4f01-4391-ba04-097eea71a768', // Global Topic ID
  '136f0be1-b262-4471-9ee2-4afe9fa5eb95', // Beta
  'topic-1', // Local
];

// Bessie interactive banner image URL
export const BESSIE_IMAGE_URL = 'https://d19kyknqbexfz7.cloudfront.net/US/SU_Campus_Redesign/Bessie_ingress_image.svg';
export const BESSIE_IMAGE_ALT = 'Bessie interactive learning image';

// Bessie card visibility constraints
export const BESSIE_SUPPORTED_LOCALES = ['en-us', 'zh-cn'];
export const BESSIE_SUPPORTED_MARKETPLACE = 'ATVPDKIKX0DER';

// Illustration alt text constants
export const ERROR_ILLUSTRATION_ALT = 'Error page image';
export const LOADING_ILLUSTRATION_ALT = 'Loading page image';
